import { TYPE_ENUM } from "@kargo/shared-components.krg-snackbar";
import { Video } from "../api/types";

export type AutocompleteProps = {
  id: number | string;
  name: string;
};

export type ActionType = "delete" | "restore";

export type VideoActionState = {
  isOpen: boolean;
  type: ActionType;
  video: Video | null;
};

export type SnackbarState = {
  type: TYPE_ENUM;
  isOpen: boolean;
  message: string;
};

export enum MediaState {
  // Only Frontend states
  UPLOADING = "uploading",
  ABORTED = "aborted",

  // API states
  EMPTY = "empty",
  PROCESSING = "processing",
  READY = "ready",
  UPLOADED = "uploaded",
  FAILED = "failed",
  SOFT_DELETED = "soft_deleted",
  HARD_DELETED = "hard_deleted",
  DRAFT = "draft",
}

export enum BulkEditType {
  TAGS = "tags",
  CATEGORY = "category",
}
